import {
	type ApplicationEditions,
	PREMIUM_EDITION,
} from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const isPremiumTenant = (editions: ApplicationEditions): boolean =>
	Object.values(editions).some((edition) => edition === PREMIUM_EDITION);

export const useIsPremiumTenant = (): boolean => {
	const editions = useAppEditions();

	return isPremiumTenant(editions);
};
